// extracted by mini-css-extract-plugin
module.exports = {"total":"StatisticsTotals_total__3-bEp","label":"StatisticsTotals_label__NgD2e","value":"StatisticsTotals_value__I4x9_"};